export function attemptOpenUrlWithFallback(url: string, repositoryNwo: string) {
  const command = `git clone https://github.com/${repositoryNwo}.git && code ${repositoryNwo.split('/')[1]}`

  window.open(url, '_self')

  // Fallback: let's also copy to clipboard a basic git clone command
  if (navigator.clipboard) {
    void navigator.clipboard.writeText(command)
  }
}
